export const isSmartLookSupported = () => {
  const specificFeatures = {
    replaceAll: typeof String.prototype.replaceAll === 'function',
    consoleWarn: typeof console.warn === 'function',
    apply: typeof Function.prototype.apply === 'function',
    queueMicrotask: typeof window.queueMicrotask === 'function',
    arrayFrom: typeof Array.from === 'function',
    arrayFind: typeof Array.prototype.find === 'function',
    arrayFindIndex: typeof Array.prototype.findIndex === 'function',
    arrayFlat: typeof Array.prototype.flat === 'function',
    arrayFlatMap: typeof Array.prototype.flatMap === 'function',
    arrayIncludes: typeof Array.prototype.includes === 'function',
    elementAppend: typeof Element.prototype.append === 'function',
    eventComposedPath: typeof Event.prototype.composedPath === 'function',
    nodeGetRootNode: 'getRootNode' in Node.prototype,
    nodeIsConnected: 'isConnected' in Node.prototype,
    objectAssign: typeof Object.assign === 'function',
    objectEntries: typeof Object.entries === 'function',
    objectFromEntries: typeof Object.fromEntries === 'function',
    objectHasOwn: typeof Object.hasOwn === 'function',
    objectSetPrototypeOf: typeof Object.setPrototypeOf === 'function',
    objectValues: typeof Object.values === 'function',
    stringIncludes: typeof String.prototype.includes === 'function',
    stringEndsWith: typeof String.prototype.endsWith === 'function',
    stringStartsWith: typeof String.prototype.startsWith === 'function',
    fetch: typeof window.fetch === 'function',
    abortController: typeof window.AbortController === 'function',
    messageChannel: typeof window.MessageChannel === 'function',
    messagePort: typeof window.MessagePort === 'function',
    sendBeacon: typeof window.navigator?.sendBeacon === 'function',
    requestIdleCallback: typeof window.requestIdleCallback === 'function',
    promiseAny: typeof window.Promise?.any === 'function',
    resizeObserver: typeof window.ResizeObserver === 'function',
    symbolAsyncIterator: typeof window.Symbol?.asyncIterator === 'symbol',
    reflect: typeof window.Reflect === 'object',
    uint8ArrayReduce: typeof Uint8Array.prototype.reduce === 'function',
    localStorage: (() => {
      try {
        return typeof window.localStorage !== 'undefined';
      } catch {
        return false;
      }
    })(),
    sessionStorage: (() => {
      try {
        return typeof window.sessionStorage !== 'undefined';
      } catch {
        return false;
      }
    })(),
  };

  return Object.values(specificFeatures).every(Boolean);
};
